export default "__VITE_ASSET__2oNi3oJA__"